export class InputManager {
  public keys: Set<string> = new Set();
  public mouseX = 0;
  public mouseY = 0;
  public mouseDeltaX = 0;
  public mouseDeltaY = 0;
  public mouseDown = false;
  public mouseRight = false;
  public isPointerLocked = false;
  public wheelDelta = 0;

  // Mapped inputs (updated each frame)
  public moveForward = 0;
  public moveRight = 0;
  public sprint = false;
  public jump = false;
  public fire = false;
  public enterExitTank = false;
  public switchWeapon = -1;
  public tabHeld = false;

  private enterExitPressed = false;
  private weaponSwitchConsumed = false;

  constructor() {
    window.addEventListener('keydown', this.onKeyDown.bind(this));
    window.addEventListener('keyup', this.onKeyUp.bind(this));
    window.addEventListener('mousedown', this.onMouseDown.bind(this));
    window.addEventListener('mouseup', this.onMouseUp.bind(this));
    window.addEventListener('mousemove', this.onMouseMove.bind(this));
    window.addEventListener('wheel', this.onWheel.bind(this));
    document.addEventListener('pointerlockchange', this.onPointerLockChange.bind(this));
  }

  public requestPointerLock(): void {
    document.body.requestPointerLock();
  }

  public update(): void {
    // Movement
    this.moveForward = 0;
    this.moveRight = 0;
    if (this.keys.has('KeyW') || this.keys.has('ArrowUp')) this.moveForward += 1;
    if (this.keys.has('KeyS') || this.keys.has('ArrowDown')) this.moveForward -= 1;
    if (this.keys.has('KeyA') || this.keys.has('ArrowLeft')) this.moveRight -= 1;
    if (this.keys.has('KeyD') || this.keys.has('ArrowRight')) this.moveRight += 1;

    // Sprint
    this.sprint = this.keys.has('ShiftLeft') || this.keys.has('ShiftRight');

    // Jump
    this.jump = this.keys.has('Space');

    // Fire
    this.fire = this.mouseDown;

    // Enter/exit tank (E key — trigger once per press)
    const eDown = this.keys.has('KeyE');
    this.enterExitTank = eDown && !this.enterExitPressed;
    this.enterExitPressed = eDown;

    // Weapon switch (number keys 1-5)
    this.switchWeapon = -1;
    for (let i = 1; i <= 5; i++) {
      if (this.keys.has(`Digit${i}`)) {
        if (!this.weaponSwitchConsumed) {
          this.switchWeapon = i - 1;
          this.weaponSwitchConsumed = true;
        }
        break;
      }
    }
    if (![1, 2, 3, 4, 5].some(i => this.keys.has(`Digit${i}`))) {
      this.weaponSwitchConsumed = false;
    }

    // Tab
    this.tabHeld = this.keys.has('Tab');
  }

  public resetDeltas(): void {
    this.mouseDeltaX = 0;
    this.mouseDeltaY = 0;
    this.wheelDelta = 0;
  }

  private onKeyDown(e: KeyboardEvent): void {
    this.keys.add(e.code);
    if (e.code === 'Tab') e.preventDefault();
  }

  private onKeyUp(e: KeyboardEvent): void {
    this.keys.delete(e.code);
  }

  private onMouseDown(e: MouseEvent): void {
    if (e.button === 0) this.mouseDown = true;
    if (e.button === 2) this.mouseRight = true;

    // Request pointer lock on first click
    if (!this.isPointerLocked) {
      this.requestPointerLock();
    }
  }

  private onMouseUp(e: MouseEvent): void {
    if (e.button === 0) this.mouseDown = false;
    if (e.button === 2) this.mouseRight = false;
  }

  private onMouseMove(e: MouseEvent): void {
    if (this.isPointerLocked) {
      this.mouseDeltaX += e.movementX;
      this.mouseDeltaY += e.movementY;
    }
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
  }

  private onWheel(e: WheelEvent): void {
    this.wheelDelta += e.deltaY;
  }

  private onPointerLockChange(): void {
    this.isPointerLocked = document.pointerLockElement === document.body;
  }
}
